import type DxfArrayScanner from '../DxfArrayScanner';

export type IPoint = {
  x: number;
  y: number;
  z?: number; //if undefined, it is a 2D point
};

export type IEntity = {
  lineType: string;
  layer: string;
  lineTypeScale: number;
  visible: boolean;
  colorIndex: number;
  color: number;
  entityFollows: number;
  inPaperSpace: boolean;
  ownerHandle: string;
  materialObjectHandle: number;
  //From https://www.woutware.com/Forum/Topic/955/lineweight?returnUrl=%2FForum%2FUserPosts%3FuserId%3D478262319
  // An integer representing 100th of mm, must be one of the following values:
  // 0, 5, 9, 13, 15, 18, 20, 25, 30, 35, 40, 50, 53, 60, 70, 80, 90, 100, 106, 120, 140, 158, 200, 211.
  // -3 = STANDARD, -2 = BYLAYER, -1 = BYBLOCK
  lineweight:
    | 0
    | 5
    | 9
    | 13
    | 15
    | 18
    | 20
    | 25
    | 30
    | 35
    | 40
    | 50
    | 53
    | 60
    | 70
    | 80
    | 90
    | 100
    | 106
    | 120
    | 140
    | 158
    | 200
    | 211
    | -3
    | -2
    | -1;
  type: EntityName;
  handle: number | string;
  standardFlags: number;

  //Note: subMarkers insertion order must be maintained when serializing
  //subMarkers are necessary for eDrawings to import dxf we serialize
  //Entities use 1 or 2 subMarker types. 3rd and 4th are added for insurance
  subMarkerCount?: number;
  subMarker1?: string;
  subMarker2?: string;
  subMarker3?: string;
  subMarker4?: string;
};

export const enum EntityName {
  Arc = 'ARC',
  Attdef = 'ATTDEF',
  Circle = 'CIRCLE',
  Dimension = 'DIMENSION',
  Ellipse = 'ELLIPSE',
  Insert = 'INSERT',
  Leader = 'LEADER',
  Line = 'LINE',
  Lwpolyline = 'LWPOLYLINE',
  MLine = 'MLINE',
  Mtext = 'MTEXT',
  Multileader = 'MULTILEADER',
  Point = 'POINT',
  Polyline = 'POLYLINE',
  Solid = 'SOLID',
  Spline = 'SPLINE',
  Text = 'TEXT',
  ThreeDFace = '3DFACE',
  Vertex = 'VERTEX',
}

export default interface IGeometry<T extends IEntity> {
  ForEntityName: EntityName;
  parseEntity(scanner: DxfArrayScanner): T;
  serializeEntity(entity: T): IterableIterator<string>;
}
